// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedPublish_main__CaMRi {
    width: 100%;
    height: 100%;
}

.ComponentListedPublish_container_component_header__FZ-SX {
    width: 100%;
    height: 50px;
}

.ComponentListedPublish_container_component_content__EUicU {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(100% - 50px);
}

.ComponentListedPublish_container_detail_list_box__SsDri {
    align-items: flex-start;
}

.ComponentListedPublish_container_detail_list_main__Rs-kc {
    width: 100%;
    height: 100%;
}

.ComponentListedPublish_container_content_left__LRZNK,
.ComponentListedPublish_container_content_right__siZE9 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 40%;
    height: 100%;
    border-radius: 12px;
}

.ComponentListedPublish_container_content_side__GNrCk {
    width: 15%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
}

.ComponentListedPublish_container_detail_list__aJ3qj {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedPublish_container_detail_list__aJ3qj::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedPublish_container_detail_list__aJ3qj::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedPublish_container_detail_list__aJ3qj::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedPublish_left_components_title__I2ADL {
    font-size: 30px;
    font-weight: bold;
}

.ComponentListedPublish_left_components__g5RPI {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedPublish_left_components__g5RPI::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedPublish_left_components__g5RPI::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedPublish_left_components__g5RPI::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedPublish_more_img__jDDjZ {
    width: 12px;
    height: 13px;
}

.ComponentListedPublish_shopping_model_item_box__DbjNS,
.ComponentListedPublish_components_add__p5PRv {
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    margin-bottom: 15px;
    cursor: pointer;
    border-radius: 12px;
    border: 2px solid #a6a6a6;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}

.ComponentListedPublish_shopping_model_item_box__DbjNS:hover {
    border: 2px solid #74BDC6;
}

.ComponentListedPublish_components_add__p5PRv {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    border: 2px solid #fff;
}

.ComponentListedPublish_components_add__p5PRv:hover {
    background-color: #f2f8f9;
}

.ComponentListedPublish_shopping_model_item_box_select__wfWKR {
    border: 2px solid #74BDC6;
}

.ComponentListedPublish_shopping_model_item__mUEc3 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* height: 93px; */
    padding: 10px 7px;
    border-radius: 12px;
}

.ComponentListedPublish_shopping_model_img_box__SjFtR {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    min-width: 51px;
    height: 51px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #FFF;
}

.ComponentListedPublish_shopping_model_img__4gWGN {
    width: 38px;
    height: 38px;
}

.ComponentListedPublish_shopping_model_text_box__823vb {
    width: calc(100% - 51px);
    padding: 0 5px;
}

.ComponentListedPublish_shopping_model_text_box_unowned__0m9q8 {
    padding: 0 10px 0 14px;
}

.ComponentListedPublish_shopping_model_text_title__JOsPa {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedPublish_shopping_model_text_info__WMlED {
    display: -webkit-box;        /* 创建一个弹性盒子 */
    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */
    -webkit-line-clamp: 3;       /* 限制显示两行 */
    overflow: hidden;            /* 隐藏超出内容 */
    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */
    color: #414648;
    font-size: 12px;
    line-height: 20px;
}

.ComponentListedPublish_container_content_right__siZE9 {
    padding: 20px;
    border: 1px solid #a6a6a6;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}

.ComponentListedPublish_right_info__N\\+qVI {
    width: 100%;
    height: 100%;
    padding: 20px;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedPublish_right_info__N\\+qVI::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedPublish_right_info__N\\+qVI::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedPublish_right_info__N\\+qVI::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedPublish_right_header_img_box__M183E {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
    border-radius: 12px;
    border: 1px solid #e6e6e6;
    margin: 0 auto;
}

.ComponentListedPublish_right_header_img__U11XQ {
    width: 100px;
    height: 100px;
}

.ComponentListedPublish_right_header_text_box__lDxWg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.ComponentListedPublish_right_header_text__r6Y5G {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 18px;
    color: #101417;
    margin: 10px 0 20px 0;
}

.ComponentListedPublish_introduce_box__S8e61,
.ComponentListedPublish_example_box__iWSj7 {
    width: 100%;
    padding: 10px 0;
}

.ComponentListedPublish_introduce_title__5QRdg,
.ComponentListedPublish_example_title__jeZXE {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedPublish_introduce_text__eXGjP,
.ComponentListedPublish_example_text__2BwG6 {
    width: 100%;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #414648;
}

.ComponentListedPublish_example_text__2BwG6 img {
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedPublish/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,yEAA2C,UAAU;IACjD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,+EAAiD,WAAW;IACxD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,mEAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,yEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB,SAAS,aAAa;IAC1C,4BAA4B,EAAE,oBAAoB;IAClD,qBAAqB,QAAQ,WAAW;IACxC,gBAAgB,aAAa,WAAW;IACxC,uBAAuB,MAAM,iBAAiB;IAC9C,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,+DAAgC,UAAU;IACtC,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,qEAAsC,WAAW;IAC7C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.container_component_header {\n    width: 100%;\n    height: 50px;\n}\n\n.container_component_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: calc(100% - 50px);\n}\n\n.container_detail_list_box {\n    align-items: flex-start;\n}\n\n.container_detail_list_main {\n    width: 100%;\n    height: 100%;\n}\n\n.container_content_left,\n.container_content_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 40%;\n    height: 100%;\n    border-radius: 12px;\n}\n\n.container_content_side {\n    width: 15%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-end;\n}\n\n.container_detail_list {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_detail_list::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.left_components_title {\n    font-size: 30px;\n    font-weight: bold;\n}\n\n.left_components {\n    width: 100%;\n    height: calc(100% - 50px);\n    padding: 0 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.left_components::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.left_components::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.left_components::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.more_img {\n    width: 12px;\n    height: 13px;\n}\n\n.shopping_model_item_box,\n.components_add {\n    width: 100%;\n    padding: 10px;\n    background-color: #ffffff;\n    margin-bottom: 15px;\n    cursor: pointer;\n    border-radius: 12px;\n    border: 2px solid #a6a6a6;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);\n}\n\n.shopping_model_item_box:hover {\n    border: 2px solid #74BDC6;\n}\n\n.components_add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    border: 2px solid #fff;\n}\n\n.components_add:hover {\n    background-color: #f2f8f9;\n}\n\n.shopping_model_item_box_select {\n    border: 2px solid #74BDC6;\n}\n\n.shopping_model_item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    /* height: 93px; */\n    padding: 10px 7px;\n    border-radius: 12px;\n}\n\n.shopping_model_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 51px;\n    min-width: 51px;\n    height: 51px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #FFF;\n}\n\n.shopping_model_img {\n    width: 38px;\n    height: 38px;\n}\n\n.shopping_model_text_box {\n    width: calc(100% - 51px);\n    padding: 0 5px;\n}\n\n.shopping_model_text_box_unowned {\n    padding: 0 10px 0 14px;\n}\n\n.shopping_model_text_title {\n    width: 100%;\n    height: 28px;\n    line-height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.shopping_model_text_info {\n    display: -webkit-box;        /* 创建一个弹性盒子 */\n    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */\n    -webkit-line-clamp: 3;       /* 限制显示两行 */\n    overflow: hidden;            /* 隐藏超出内容 */\n    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */\n    color: #414648;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.container_content_right {\n    padding: 20px;\n    border: 1px solid #a6a6a6;\n    background-color: #ffffff;\n    border-radius: 12px;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);\n}\n\n.right_info {\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    border: 1px solid #ebebeb;\n    border-radius: 6px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.right_info::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.right_info::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.right_info::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.right_header_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 118px;\n    border-radius: 12px;\n    border: 1px solid #e6e6e6;\n    margin: 0 auto;\n}\n\n.right_header_img {\n    width: 100px;\n    height: 100px;\n}\n\n.right_header_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_header_text {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 18px;\n    color: #101417;\n    margin: 10px 0 20px 0;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    line-height: 16px;\n    color: #414648;\n}\n\n.example_text img {\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ComponentListedPublish_main__CaMRi`,
	"container_component_header": `ComponentListedPublish_container_component_header__FZ-SX`,
	"container_component_content": `ComponentListedPublish_container_component_content__EUicU`,
	"container_detail_list_box": `ComponentListedPublish_container_detail_list_box__SsDri`,
	"container_detail_list_main": `ComponentListedPublish_container_detail_list_main__Rs-kc`,
	"container_content_left": `ComponentListedPublish_container_content_left__LRZNK`,
	"container_content_right": `ComponentListedPublish_container_content_right__siZE9`,
	"container_content_side": `ComponentListedPublish_container_content_side__GNrCk`,
	"container_detail_list": `ComponentListedPublish_container_detail_list__aJ3qj`,
	"left_components_title": `ComponentListedPublish_left_components_title__I2ADL`,
	"left_components": `ComponentListedPublish_left_components__g5RPI`,
	"more_img": `ComponentListedPublish_more_img__jDDjZ`,
	"shopping_model_item_box": `ComponentListedPublish_shopping_model_item_box__DbjNS`,
	"components_add": `ComponentListedPublish_components_add__p5PRv`,
	"shopping_model_item_box_select": `ComponentListedPublish_shopping_model_item_box_select__wfWKR`,
	"shopping_model_item": `ComponentListedPublish_shopping_model_item__mUEc3`,
	"shopping_model_img_box": `ComponentListedPublish_shopping_model_img_box__SjFtR`,
	"shopping_model_img": `ComponentListedPublish_shopping_model_img__4gWGN`,
	"shopping_model_text_box": `ComponentListedPublish_shopping_model_text_box__823vb`,
	"shopping_model_text_box_unowned": `ComponentListedPublish_shopping_model_text_box_unowned__0m9q8`,
	"shopping_model_text_title": `ComponentListedPublish_shopping_model_text_title__JOsPa`,
	"shopping_model_text_info": `ComponentListedPublish_shopping_model_text_info__WMlED`,
	"right_info": `ComponentListedPublish_right_info__N+qVI`,
	"right_header_img_box": `ComponentListedPublish_right_header_img_box__M183E`,
	"right_header_img": `ComponentListedPublish_right_header_img__U11XQ`,
	"right_header_text_box": `ComponentListedPublish_right_header_text_box__lDxWg`,
	"right_header_text": `ComponentListedPublish_right_header_text__r6Y5G`,
	"introduce_box": `ComponentListedPublish_introduce_box__S8e61`,
	"example_box": `ComponentListedPublish_example_box__iWSj7`,
	"introduce_title": `ComponentListedPublish_introduce_title__5QRdg`,
	"example_title": `ComponentListedPublish_example_title__jeZXE`,
	"introduce_text": `ComponentListedPublish_introduce_text__eXGjP`,
	"example_text": `ComponentListedPublish_example_text__2BwG6`
};
export default ___CSS_LOADER_EXPORT___;
